import React, { useContext } from 'react';

import { GlobalContext } from '../../../../../store';

import { useTeamsCreatorState, useTeamsCreatorDispatch } from '../Context/TeamsCreator.context';
import { TeamCard } from '../../../../../components/TeamCard/TeamCard';
import { useRouteInfoState } from '../../../../../components/RouteInfo/Context/RouteInfo.context';
import { EmptyTeamCard } from './EmptyTeamCard';

export const AddNewTeamCard = () => {
  const {
    actions: {
      adminEventTeams: { create: createAdminEventTeam }
    }
  } = useContext(GlobalContext);

  const { clubId, eventId } = useRouteInfoState();

  const { displayNewTeam, newTeam } = useTeamsCreatorState();
  const { dispatch } = useTeamsCreatorDispatch();

  const onAddNewTeamClick = async () => {
    const newCreatedTeam = await createAdminEventTeam(clubId, eventId, {
      enrollments: []
    });

    if (eventId) {
      dispatch({ type: 'selectTeam', value: newCreatedTeam.adminEventTeams[eventId].slice(-1)[0] });
    }
  };

  return displayNewTeam ? (
    <TeamCard context="teams" team={newTeam} />
  ) : (
    <EmptyTeamCard elevation={1} className="paper team-card" onClick={onAddNewTeamClick}>
      <span>+</span>
      <span>ADD NEW TEAM</span>
    </EmptyTeamCard>
  );
};
